module.exports = __webpack_public_path__ + "static/media/promoBackgroundEn.c0a2732e.png";